<template>
    <b-row>
        <b-col cols="12">
            <h2 class="m-0 h1 text-uppercase">
                {{ $t('parcelas.selecciona_region') }}
            </h2>
        </b-col>
        <b-col cols="12">
            <transition name="fade" mode="out-in">
                <b-row key="zonas" id="zonas">
                    <b-col cols="12" md="8">
                        <h3 class="subtitle h3 light mb-3">{{ $t('partido.pinchando_mapa') }}:</h3>
                        <ContentOrLoading>
                            <div class="lightgray-content" v-if="!loading">
                                <SvgComponent 
                                    :zonas="zonas" 
                                    :place_id="lista.recinto_parcela_id"
                                    :config_precios="true"
                                    @clickZona="finalizarPaso"
                                    @cargado="onMapaCargado"
                                />
                            </div>
                        </ContentOrLoading>
                    </b-col>
                </b-row>
            </transition>
        </b-col>
    </b-row>
</template>

<script>
    import SvgComponent from '@/components/svg/SvgComponent';

    export default {
        data() {
            return {
                zonas: null,
                loading: false,
                isMapaCargado: false
            } 
        },
        methods: {
            onMapaCargado() {
                this.isMapaCargado = true;
                this.loading = false;
            },
            finalizarPaso(zona) {
                this.$emit('terminado', zona);
            },
            getZonas() {
                this.loading = true;

                const params = {
                    filters: {},
                    lista_abonado_id: this.lista.id,
                    place_id: this.lista.recinto_parcela_id,
                }

                this.$store.dispatch(this.config.getVuexAlias('front.parcelas.zonas'), params).then(res => {
                    this.zonas = res.data.data;
                }).finally(() => {
                    this.loading = false;
                });
            }
        },
        computed: {
            lista() {
                return this.$store.getters.getListaAbonados;
            }
        },
        created() {
            this.getZonas();
        },
        components: {
            SvgComponent
        }
    }
</script>